/// <amd-module name="Test/TestPlansHubRefresh/TestRunsMenu/AssignTesterPeoplePickerProvider" />
import * as ExecuteConstants from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/ExecuteConstants";
import * as ExecuteResources from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Resources";
import { PeoplePickerProvider } from "VSS/Features/Identities/IdentityPickerProvider";
import { IdentitiesSearchRequestModel } from "VSS/Features/Identities/IdentityService";
import { IVssPageContext } from "VSS/Platform/Context";
import { getAssetLocation } from "VSS/Platform/Location";
import { IIdentity } from "VSSUI/IdentityPicker";

// This implements the PeoplePickerprovider. The purpose of this is to add the unassigned Identity in the dropdown for unassign capability
export class AssignTesterPeoplePickerProvider extends PeoplePickerProvider {
    private _pageContext: IVssPageContext;
    private _unassignedIdentity: IIdentity;

    constructor(pageContext: IVssPageContext, defaultRequestProps?: Partial<IdentitiesSearchRequestModel>) {
        super(pageContext, defaultRequestProps);
        this._pageContext = pageContext;
        this._unassignedIdentity = {
            displayName: ExecuteResources.UnassignedIdentity,
            entityId: "",
            entityType: "",
            originDirectory: "",
            originId: "",
            image: getAssetLocation(this._pageContext, ExecuteConstants.UnassignedIdentityIconPath)
        };
    }

    public onEmptyInputFocus(): IIdentity[] | PromiseLike<IIdentity[]> {
        const identities = super.onEmptyInputFocus();
        if (Array.isArray(identities)) {
            identities.unshift(this._unassignedIdentity);
            return identities;
        } else {
            return identities.then(identities => {
                identities.unshift(this._unassignedIdentity);
                return identities;
            });
        }
    }
}
